import { VariableType } from 'json-to-graphql-query';
import { EntityResource } from './entity.resource';
/**
 * Moduł stron
 *
 * @export
 * @class PageResource
 * @extends {EntityResource<Page>}
 */
export class PageResource extends EntityResource {
    constructor() {
        super({
            entityName: 'page'
        });
        this.getFields = {
            mainImage: true,
            images: true,
            name: true,
            slug: true,
            priority: true,
            state: true,
            type: true,
            content: true,
            data: true,
            slots: true,
            media: true
        };
        this.listFields = {
            id: true,
            name: true,
            state: true,
            priority: true,
            type: true
        };
        this.addVariables = { page: 'PageInput!' };
        this.addArgs = { page: new VariableType('page') };
        this.updateVariables = { id: 'Int!', page: 'PageInput!' };
        this.updateArgs = {
            id: new VariableType('id'),
            page: new VariableType('page')
        };
        this.listVariables = { filters: 'PageFilters' };
    }
}
export const pageResource = new PageResource();
//# sourceMappingURL=page.resource.js.map